import { c as _c } from "react/compiler-runtime";
import { useApplePayActions } from 'modules/profile/payment-gateways/integrations/stripe/hooks';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { BinIcon } from '@systemeio/ui/icons';
interface ApplePayDeleteDomainModalProps {
  domainId: number;
  hostName: string;
  afterLeave: () => void;
}
const ApplePayDeleteDomainModal = t0 => {
  const $ = _c(16);
  const {
    domainId,
    hostName,
    afterLeave
  } = t0;
  const [opened, setOpened] = useState(false);
  const {
    disconnectDomain
  } = useApplePayActions();
  let t1;
  if ($[0] !== disconnectDomain || $[1] !== domainId) {
    t1 = async () => {
      await disconnectDomain(domainId);
      setOpened(false);
    };
    $[0] = disconnectDomain;
    $[1] = domainId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleConfirm = t1;
  let t2;
  if ($[3] !== hostName) {
    t2 = <span>{hostName}</span>;
    $[3] = hostName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BinIcon onClick={() => setOpened(true)} className="fill-danger mb-0.5 h-[16px] w-[16px] cursor-pointer" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="flex">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(false);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== afterLeave || $[10] !== handleConfirm || $[11] !== opened) {
    t6 = <ConfirmationModal opened={opened} afterLeave={afterLeave} onClose={t5} onConfirm={handleConfirm} />;
    $[9] = afterLeave;
    $[10] = handleConfirm;
    $[11] = opened;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default ApplePayDeleteDomainModal;